module.exports = function () {
    var buildEvent = function (keywords) {
        var dyEvent = new CustomEvent('dynamicYieldEvent', {
            detail: {
                name: 'Keyword Search',
                properties: {
                    dyType: 'keyword-search-v1',
                    keywords: keywords || ''
                }
            }
        });
        document.body.dispatchEvent(dyEvent);
    };

    $('[name="simpleSearch"]').submit(function () {
        var keywords = $(this).serializeArray().find(function (field) {
            return field.name === 'q';
        });
        buildEvent(keywords.value);
    });

    $('body').on('click keyup', '.suggestions-wrapper [id|="phrase"]', function (e) {
        var code = e.keyCode || e.which;
        if (e.type === 'keyup' && code !== 13) {
            // if key is not enter, short circuit.
            return;
        }

        var keywords = $(this).text().trim();
        buildEvent(keywords);
    });
};
